<template>
  <div id="app">
    <IntroTutorial v-if="showIntroTutorial"></IntroTutorial>
    <MessageBox></MessageBox>
    <Share></Share>
    <LoadingScreen></LoadingScreen>
    <Header></Header>
    <div id="content">
      <router-view/>
    </div>
    <ScrollIndicator v-if="isMobile"></ScrollIndicator>
    <CookieNotification v-if="showCookieNotification" @cookieNotificationRemove="showCookieNotification = false; addStatistics();"></CookieNotification>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import MessageBox from '@/components/MessageBox.vue';
import Share from '@/components/Share.vue';
import LoadingScreen from '@/components/utilities/LoadingScreen.vue';
import ScrollIndicator from '@/components/utilities/ScrollIndicator.vue'
import CookieNotification from '@/components/cookies/CookieNotification.vue'
import { EventBus } from '@/main.js'
// import Profile from '@/assets/profile/Profile.js'
import axios from 'axios'
import IntroTutorial from '@/components/tutorials/IntroTutorial.vue'

export default {
  data() {
    return {
      isMobile: false,
      showCookieNotification: false,
      showIntroTutorial: false,
    }
  },
  components: {
    Header, MessageBox, LoadingScreen, ScrollIndicator, CookieNotification, Share, IntroTutorial
  },
  beforeCreate() {
    // Profile.checkForPreviousLogin();
    this.$DeviceCheck.initialize().then(() => {
      this.isMobile = this.$DeviceCheck.isMobile;
    });
  },
  created() {
    EventBus.$on('changeCookieSettings', () => {
  		this.showCookieNotification = true;
    });

    this.checkForImportantNotifications();

    var cookieSettings = JSON.parse(localStorage.getItem('OdenseRundt-CookieNotice'));
    if(cookieSettings == undefined || cookieSettings == null) {
			this.showCookieNotification = true;
		}
    //Check if cookie timestamp is 1 year old
    else if(Date.now() > cookieSettings.timeStamp) {
      this.showCookieNotification = true;
    }

    if(localStorage.getItem('OdenseRundt-TutorialIntro') == 'true') {
      this.showIntroTutorial = true;
    }

    this.addStatistics();

    //Solution for not showing the default focus outline when clicked by mouse, but enable when user uses tab
    window.addEventListener('keydown', this.userIsUsingTab);
  },
  methods: {
    userIsUsingTab(e) {
      if(e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', this.userIsUsingTab);
        window.addEventListener('mousedown', this.userIsUsingMouse);
      }
    },

    userIsUsingMouse() {
      document.body.classList.remove('user-is-tabbing');
      window.removeEventListener('mousedown', this.userIsUsingMouse);
      window.addEventListener('keydown', this.userIsUsingTab);
    },

    addStatistics() {
      if(localStorage.getItem('OdenseRundt-StatisticsCookies') == 'true') {
        if(navigator.userAgent.indexOf('prerender') == -1 && window.location.href.indexOf('localhost') == -1) {
  				var sz = document.createElement('script'); sz.type = 'text/javascript'; sz.async = true;
  				sz.src = '//siteimproveanalytics.com/js/siteanalyze_293239.js';
  				var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sz, s);
  		  }
      }
    },

    checkForImportantNotifications() {
      var platform = 'web';
    	if(this.$DeviceCheck.isMobile) { platform = 'mobile' }
    	if(this.$DeviceCheck.isIOS) { platform = 'ios' }
    	if(this.$DeviceCheck.isAndroid) { platform = 'android' }

      axios.get('https://api.odenserundt.dk/v1/notify/'+platform)
      .then(response => {
        var notificationData = response.data;
        var message = '';
    		for(var i in notificationData) {
    			if(notificationData[i].important == true) {
    				var timeNow = Date.now();
    				if(timeNow/1000 < notificationData[i].expire) {
    					var alreadyShown = localStorage.getItem('OdenseRundt-Notification-'+notificationData[i].id);
    					if(alreadyShown != 'true') {
    						message += '<h3>'+notificationData[i].title+'</h3>'+notificationData[i].message+'<br>';
                if(localStorage.getItem('OdenseRundt-FunctionalCookies') == 'true') {
                  localStorage.setItem('OdenseRundt-Notification-'+notificationData[i].id, 'true');
                }
    					}
    				}
    			}
    		}
    		if(message != '') {
          var obj = {message: message, btnText: 'Ok'};
          EventBus.$emit('openMessageBox', obj);
    		}
      })
      .catch(function (error) {
        console.log(error);
      });

  	},
  }
}
</script>

<style lang="scss">
@import '~shepherd.js/dist/css/shepherd.css';
@import '~@/assets/css/tutorials.css';
@import '~@/assets/css/colors.css';
@import '~@/assets/css/helperClasses.css';
@import '~@/assets/css/favorites.css';
@import '~@/assets/css/leafletZoom.css';
@import '~@/assets/css/mapPopup.css';
@import '~@/assets/css/markers.css';

html, body {
	font-family: 'Roboto Condensed', sans-serif !important;
  font-size: 14px;
	color: #424242;
	background-color: #f1f1f1;
	height: 100%;
	width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  margin: 0;
}

a {
  color: rgb(0,112,141);
  cursor: pointer;
}

ol, ul {
  padding: 0;
  margin: 0;
	list-style: none;
}

#app {
  height: 100%;
  width: 100%;
}

/*Solution to removing focus outline for none keyboard users*/
body:not(.user-is-tabbing) button:focus,
body:not(.user-is-tabbing) input:focus,
body:not(.user-is-tabbing) select:focus,
body:not(.user-is-tabbing) textarea:focus,
body:not(.user-is-tabbing) div:focus,
body:not(.user-is-tabbing) li:focus {
  outline: none;
}

#content {
  position: relative;
  height: 100%;
  width: 100%;
  right: 0;
	padding-top: 50px;
  padding-left: 5px;
	padding-right: 5px;
	background-color: #f1f1f1;
  -moz-transition:all 200ms ease-in;
  -webkit-transition:all 200ms ease-in;
  -o-transition:all 200ms ease-in;
  transition:all 200ms ease-in;
}

#content.menu-open {
  right: 250px;
}

.white-box {
	background-color: #fdfdfd;
	height: auto;
	box-shadow: 0 1px 2px rgba(0,0,0,.1);
}

/*Landscape - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
	#content {
		padding-top: 40px;
	}
}

/*Portrait - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
	#content {
		padding-top: 40px;
	}
}

/*Material icons*/
.material-icons {
	font-family: 'Material Icons';
	font-weight: normal;
	font-style: normal;
	font-size: 30px !important;  /* Preferred icon size */
	display: inline-block;
	line-height: 1;
	text-transform: none;
	letter-spacing: normal;
	word-wrap: normal;
	white-space: nowrap;
	direction: ltr;

	/* Support for all WebKit browsers. */
	-webkit-font-smoothing: antialiased;
	/* Support for Safari and Chrome. */
	text-rendering: optimizeLegibility;

	/* Support for Firefox. */
	-moz-osx-font-smoothing: grayscale;

	/* Support for IE. */
	font-feature-settings: 'liga';
}

.modal-background {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-fade-enter, .modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity .5s ease
}

</style>
